// You can write your custom Javascript here

/* CUSTOM - Replace "10 Reviews" with (10) */


jQuery(document).ready(function($){
	setTimeout(function(){
		$('.section-collection .text-m').each(function(){
			var review = $(this).html()
			console.log(review)
			var reviews = review.split(' ')[0]
			review = '(' + reviews + ')'
			$(this).html(review)
		})
	}, 3000)
});

jQuery(document).ready(function($){
	setTimeout(function(){
		$('.section__content--related .text-m').each(function(){
			var review = $(this).html()
			console.log(review)
			var reviews = review.split(' ')[0]
			review = '(' + reviews + ')'
			$(this).html(review)
		})
	}, 3000)
});

jQuery(document).ready(function($){
	setTimeout(function(){
		$('.name-input label').text('Your name')
	}, 3000)
});


jQuery(document).ready(function($){
	setTimeout(function(){
    	$(".detailsReviews").on("click", function() {
  			$('.tabs__nav li').removeClass('is-current');
  			$('.tabs__body .tab').removeClass('is-current');
  			$('.tabs__body .reviews-tab').addClass('is-current');
  			$('.tabs__nav li:last-child').addClass('is-current');
  			$('.tab:last-child').addClass('is-current');
		});
	}, 500)
});

jQuery(document).ready(function($) {
    if (window.location.href.indexOf("?contact_posted=true") > -1) {
  			$('#request-button').addClass('hidden');
  			$('.form-feedback--success').removeClass('hidden');
    }
});